import { createSlice } from '@reduxjs/toolkit'


export const ModalCommonStore = createSlice({
  name: 'menuStore',
  initialState: {
    modalZoom: {
      show: false,
      typeView: '',
    }
  },
  reducers: {
    toggleModalZoom: (state: any, actions: any) => {
      state.modalZoom.show = !state.modalZoom.show
      state.modalZoom.typeView = actions?.payload
    },
  }
})

// Action creators are generated for each case reducer function
export const { toggleModalZoom } = ModalCommonStore.actions

export default ModalCommonStore.reducer